<!-- A wrapper component for an input inside a form group with validation -->

<template>
  <ValidationProvider
    v-bind="$attrs"
    :rules="rules"
    v-slot="{ errors, invalid }"
  >
    <b-form-group v-bind="$attrs">
      <b-input
        v-if="!textArea"
        v-bind="$attrs"
        v-model="innerValue"
        :invalid="invalid"
        :list="dataListId"
      />
      <b-textarea
        v-if="textArea"
        v-bind="$attrs"
        v-model="innerValue"
        class="tsny_input-text-area"
        :invalid="invalid"
      />
      <div v-if="dataList">
        <b-datalist :id="dataListId">
          <option :key="listItem" v-for="listItem in dataList">
            {{ listItem }}
          </option>
        </b-datalist>
      </div>
      <slot :errors="errors">
        <p class="tsny_field_error-text">
          {{ errors[0] }}
        </p>
      </slot>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en";

// loop over all rules
for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: en.messages[rule] // add its message
  });
}

extend("required", {
  message: "Required"
});

extend("password", {
  computesRequired: true,
  message: "Passwords do not match.",
  params: [{ name: "other", isTarget: true }],
  validate: (value, { other }) => {
    let isEmpty = !!(!value || value.length === 0);
    return { valid: !isEmpty && value === other, required: true };
  }
});

export default {
  name: "BTextInputValidated",
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [String, Object],
      default: null
    },
    value: {
      type: null,
      default: null
    },
    textArea: {
      type: Boolean,
      default: null
    },
    dataList: {
      type: Array,
      default: null
    }
  },
  computed: {
    // Since we need to link an input to a datalist via an ID, we need to generate a random ID so that multiple datalists can be on the same page
    dataListId() {
      return "dataList_" + Math.random();
    }
  },
  data: () => ({ innerValue: null }),
  created() {
    this.innerValue = this.value;
  },
  watch: {
    innerValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: -0.5rem;
}
</style>
